import { Chip, Divider, List, ListItem, Typography, useTheme } from '@mui/material';
import { Stack } from '@mui/system';
import CheckIcon from '@mui/icons-material/Check';
import { FormButton } from '../../UI';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

interface IBillingCardProps {
  options: string[];
  name: string;
  description: string;
  price?: number;
  isActive: boolean;
  onSubscribe: () => void;
}

const BillingCard: React.FC<IBillingCardProps> = ({
  name,
  options,
  description,
  price = 0,
  isActive,
  onSubscribe,
}) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        background: theme.custom.palette.primary.white,
        padding: '20px',
        borderRadius: '8px',
        gap: '20px',
        flexShrink: 0,
        border: isActive ? `3px solid ${theme.custom.palette.primary.default}` : 'none',
      }}
    >
      <Chip
        label={name}
        sx={{
          alignSelf: 'flex-start',
          background: isActive ? theme.custom.palette.primary.default : '#f2f5f9',
          color: isActive ? theme.custom.palette.primary.white : theme.custom.palette.primary.default,
          fontWeight: 600,
        }}
      />
      {price ? (
        <Typography variant={'h1'}>
          ₽ {price}
        </Typography>
      ) : (
        <Typography variant={'h1'}>По запросу</Typography>
      )}
      <Typography variant={'subtitle1'}>{description}</Typography>
      <Divider light />

      <List sx={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
        {options.map((option, idx) => (
          <ListItem key={idx} disablePadding sx={{ gap: '10px' }}>
            <CheckIcon sx={{ color: '#4bc461' }} /> <Typography>{option}</Typography>
          </ListItem>
        ))}
      </List>

      <Stack sx={{ marginTop: 'auto' }}>
        <FormButton
          endIcon={<ArrowForwardRoundedIcon />}
          variant={isActive ? 'primary' : 'secondary'}
          onClick={onSubscribe}
        >
          Выбрать
        </FormButton>
      </Stack>
    </Stack>
  );
};

export default BillingCard;
